import React, { useContext } from "react";
import { CommandBarButton, useDisclosure } from "sprint-common-web";

import { AuthorizationWrapper } from "../../../../../core/security/AuthorizationWrapper";
import { SprintAccessRight } from "../../../../../core/security/SprintAccessRight";
import { FileRecordListingContext } from "../../context/FileRecordListingContext";
import { ApproveFileRecordNotificationsDialog } from "./ApproveFileRecordNotificationsDialog";
import { mapToApproveNotificationsItem } from "./ApproveNotificationsItem";

export const ApproveFileRecordNotificationsButton: React.VFC = () => {
    const { selectedItems } = useContext(FileRecordListingContext);
    const { isOpen, onClose, onOpen } = useDisclosure();

    return (
        <AuthorizationWrapper accessRights={[SprintAccessRight.CiReadWrite]}>
            <CommandBarButton
                text="Approve notifications"
                icon="Ringer"
                disabled={!selectedItems.length}
                onClick={onOpen}
            />
            <ApproveFileRecordNotificationsDialog
                key={String(isOpen)}
                isOpen={isOpen}
                onClose={onClose}
                selectedItems={selectedItems.map(mapToApproveNotificationsItem)}
            />
        </AuthorizationWrapper>
    );
};
